import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IAssessmentList,
  IClientSearch,
  IHubspotData,
} from '@core/models/client.model';
import { Observable } from 'rxjs';
import { DepartmentsResponse} from './../models/department.model';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  constructor(private readonly httpClient: HttpClient) {}

  // Method to get client details
  /* istanbul ignore next */
  getClientDetails(requestData: IClientSearch): Observable<IHubspotData> {
    return this.httpClient.post<IHubspotData>('sra-details', requestData, {
      params: {
        _config: JSON.stringify({ noNotifyError: false }),
      },
    });
  }

  // Method to get assessment list
  /* istanbul ignore next */
  getAssessmentList(crmId: string): Observable<IAssessmentList[]> {
    return this.httpClient.post<IAssessmentList[]>(
      'sra-AssessmentLists',
      { crmId },
      {
        params: {
          _config: JSON.stringify({ noNotifyError: false }),
        },
      },
    );
  }

  // Method to getdepartments
  /* istanbul ignore next */
  login(): Observable<DepartmentsResponse> {
    return this.httpClient.post<DepartmentsResponse>(
      'login',
      {
        params: {
          _config: JSON.stringify({ noNotifyError: false }),
        },
      },
    );
  }
}
